import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from './session.service';
import { environment as env } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { getHeaders } from '../utils/headersUtils';
import { IEstadisticosLicitacion, IListLicitacion } from 'src/app/models/mercado-publico/mercado-publico-licitacion.model';
import { IEstadisticosOrden, IListOrdenCompra } from 'src/app/models/mercado-publico/mercado-publico-orden-compra.model';
import { IResponseDescargas, IResponseGenerar } from 'src/app/models/mercado-publico/mercado-publico-listado-descargas.model';

@Injectable({
  providedIn: 'root'
})
export class MercadoPublicoService {
  private endpoint: string = env.backend.mercadoPublico.url;

  constructor(
    private http: HttpClient,
    private _sessionService: SessionService,
  ) { }

  obtenerLicitaciones(
    page?: number,
    size?: number,
    fechaDesde?: string,
    fechaHasta?: string,
    rutProveedor?: string, 
    codigo?: string, 
    estado?: string, 
    organismo?: string, 
    montoMinimo?: number, 
    montoMaximo?: number,
    nombreProveedor?: string,
    comuna?: string,
    region?: string
  ): Observable<IListLicitacion> {
    let params = new HttpParams();

    if(page)
      params = params.append("page", page);
    if(size)
      params = params.append("size", size);
    if(fechaDesde)
      params = params.append("fechaDesde", fechaDesde);
    if(fechaHasta)
      params = params.append("fechaHasta", fechaHasta);
    if(rutProveedor)
      params = params.append("rutProveedor", rutProveedor);
    if(codigo)
      params = params.append("codigo", codigo);
    if(estado)
      params = params.append("estado", estado);
    if(organismo)
      params = params.append("organismo", organismo);
    if(montoMinimo || montoMinimo === 0)
      params = params.append("montoMinimo", montoMinimo);
    if(montoMaximo || montoMaximo === 0)
      params = params.append("montoMaximo", montoMaximo);
    if(nombreProveedor)
      params = params.append("nombreProveedor", nombreProveedor);
    if(comuna)
      params = params.append("comuna", comuna);
    if(region)
      params = params.append("region", region);

    const headers = getHeaders(this._sessionService.getOrganization(), this._sessionService.getUserInfo().username, 'WEB');

    return this.http.get<IListLicitacion>(`${this.endpoint}listarLicitaciones`, { params, headers });
  }

  obtenerEstadisticasLicitaciones(
    fechaDesde?: string,
    fechaHasta?: string,
    rutProveedor?: string, 
    codigo?: string, 
    estado?: string, 
    organismo?: string, 
    montoMinimo?: number, 
    montoMaximo?: number,
    nombreProveedor?: string,
    comuna?: string,
    region?: string
  ): Observable<IEstadisticosLicitacion> {
    let params = new HttpParams();

    if(fechaDesde)
      params = params.append("fechaDesde", fechaDesde);
    if(fechaHasta)
      params = params.append("fechaHasta", fechaHasta);
    if(rutProveedor)
      params = params.append("rutProveedor", rutProveedor);
    if(codigo)
      params = params.append("codigo", codigo);
    if(estado)
      params = params.append("estado", estado);
    if(organismo)
      params = params.append("organismo", organismo);
    if(montoMinimo || montoMinimo === 0)
      params = params.append("montoMinimo", montoMinimo);
    if(montoMaximo || montoMaximo === 0)
      params = params.append("montoMaximo", montoMaximo);
    if(nombreProveedor)
      params = params.append("nombreProveedor", nombreProveedor);
    if(comuna)
      params = params.append("comuna", comuna);
    if(region)
      params = params.append("region", region);

    const headers = getHeaders(this._sessionService.getOrganization(), this._sessionService.getUserInfo().username, 'WEB');

    return this.http.get<IEstadisticosLicitacion>(`${this.endpoint}estadisticasLicitaciones`, { params, headers });
  }

  obtenerOrdenesCompra(
    page?: number,
    size?: number,
    fechaDesde?: string,
    fechaHasta?: string,
    rutProveedor?: string, 
    estado?: string, 
    organismo?: string, 
    montoMinimo?: number, 
    montoMaximo?: number,
    nombreProveedor?: string,
    comuna?: string,
    region?: string
  ): Observable<IListOrdenCompra> {
    let params = new HttpParams();

    if(page)
      params = params.append("page", page);
    if(size)
      params = params.append("size", size);
    if(fechaDesde)
      params = params.append("fechaDesde", fechaDesde);
    if(fechaHasta)
      params = params.append("fechaHasta", fechaHasta);
    if(rutProveedor)
      params = params.append("rutProveedor", rutProveedor);
    if(estado)
      params = params.append("estado", estado);
    if(organismo)
      params = params.append("organismo", organismo);
    if(montoMinimo || montoMinimo === 0)
      params = params.append("montoMinimo", montoMinimo);
    if(montoMaximo || montoMaximo === 0)
      params = params.append("montoMaximo", montoMaximo);
    if(nombreProveedor)
      params = params.append("nombreProveedor", nombreProveedor);
    if(comuna)
      params = params.append("comuna", comuna);
    if(region)
      params = params.append("region", region);

    const headers = getHeaders(this._sessionService.getOrganization(), this._sessionService.getUserInfo().username, 'WEB');

    return this.http.get<IListOrdenCompra>(`${this.endpoint}listarOrdenesCompra`, { params, headers });
  }

  obtenerEstadisticasOrdenesCompra(
    fechaDesde?: string,
    fechaHasta?: string,
    rutProveedor?: string, 
    estado?: string, 
    organismo?: string, 
    montoMinimo?: number, 
    montoMaximo?: number,
    nombreProveedor?: string,
    comuna?: string,
    region?: string
  ): Observable<IEstadisticosOrden> {
    let params = new HttpParams();

    if(fechaDesde)
      params = params.append("fechaDesde", fechaDesde);
    if(fechaHasta)
      params = params.append("fechaHasta", fechaHasta);
    if(rutProveedor)
      params = params.append("rutProveedor", rutProveedor);
    if(estado)
      params = params.append("estado", estado);
    if(organismo)
      params = params.append("organismo", organismo);
    if(montoMinimo || montoMinimo === 0)
      params = params.append("montoMinimo", montoMinimo);
    if(montoMaximo || montoMaximo === 0)
      params = params.append("montoMaximo", montoMaximo);
    if(nombreProveedor)
      params = params.append("nombreProveedor", nombreProveedor);
    if(comuna)
      params = params.append("comuna", comuna);
    if(region)
      params = params.append("region", region);

    const headers = getHeaders(this._sessionService.getOrganization(), this._sessionService.getUserInfo().username, 'WEB');

    return this.http.get<IEstadisticosOrden>(`${this.endpoint}estadisticasOrdenesCompra`, { params, headers });
  }

  obtenerListadoSolicitudDescarga(): Observable<IResponseDescargas> {
    const params = new HttpParams();

    const headers = getHeaders(this._sessionService.getOrganization(), this._sessionService.getUserInfo().username, 'WEB');

    return this.http.get<IResponseDescargas>(`${this.endpoint}listadoSolicitudDescarga`, { params, headers });
  }

  generarExcelLicitaciones(
    fechaDesde?: string,
    fechaHasta?: string,
    rutProveedor?: string, 
    codigo?: string, 
    estado?: string, 
    organismo?: string, 
    montoMinimo?: number, 
    montoMaximo?: number,
    nombreProveedor?: string,
    comuna?: string,
    region?: string
  ): Observable<IResponseGenerar> {
    let params = new HttpParams();

    if(fechaDesde)
      params = params.append("fechaDesde", fechaDesde);
    if(fechaHasta)
      params = params.append("fechaHasta", fechaHasta);
    if(rutProveedor)
      params = params.append("rutProveedor", rutProveedor);
    if(codigo)
      params = params.append("codigo", codigo);
    if(estado)
      params = params.append("estado", estado);
    if(organismo)
      params = params.append("organismo", organismo);
    if(montoMinimo || montoMinimo === 0)
      params = params.append("montoMinimo", montoMinimo);
    if(montoMaximo || montoMaximo === 0)
      params = params.append("montoMaximo", montoMaximo);
    if(nombreProveedor)
      params = params.append("nombreProveedor", nombreProveedor);
    if(comuna)
      params = params.append("comuna", comuna);
    if(region)
      params = params.append("region", region);

    const headers = getHeaders(this._sessionService.getOrganization(), this._sessionService.getUserInfo().username, 'WEB');

    return this.http.get<IResponseGenerar>(`${this.endpoint}generarExcelLicitaciones`, { params, headers });
  }

  generarExcelOrdenesCompra(
    fechaDesde?: string,
    fechaHasta?: string,
    rutProveedor?: string, 
    estado?: string, 
    organismo?: string, 
    montoMinimo?: number, 
    montoMaximo?: number,
    nombreProveedor?: string,
    comuna?: string,
    region?: string
  ): Observable<IResponseGenerar> {
    let params = new HttpParams();

    if(fechaDesde)
      params = params.append("fechaDesde", fechaDesde);
    if(fechaHasta)
      params = params.append("fechaHasta", fechaHasta);
    if(rutProveedor)
      params = params.append("rutProveedor", rutProveedor);
    if(estado)
      params = params.append("estado", estado);
    if(organismo)
      params = params.append("organismo", organismo);
    if(montoMinimo || montoMinimo === 0)
      params = params.append("montoMinimo", montoMinimo);
    if(montoMaximo || montoMaximo === 0)
      params = params.append("montoMaximo", montoMaximo);
    if(nombreProveedor)
      params = params.append("nombreProveedor", nombreProveedor);
    if(comuna)
      params = params.append("comuna", comuna);
    if(region)
      params = params.append("region", region);

    const headers = getHeaders(this._sessionService.getOrganization(), this._sessionService.getUserInfo().username, 'WEB');

    return this.http.get<IResponseGenerar>(`${this.endpoint}generarExcelOrdenesCompra`, { params, headers });
  }

}
